export default {
  AvenirGeo: {
    isDefault: true,
    value: [
      'Avenir Geo',
      'Avenir',
      '-apple-system',
      'BlinkMacSystemFont',
      'Segoe UI',
      'sans-serif',
    ],
    type: 'sans-serif',
  },
}
